module.exports = __webpack_public_path__ + "static/Q2Answer2_Spiders_KrzysztofNiewolny-55df1755302b9d2ad439b5af3c799850.jpg";